import React from "react";
import CustomPageHeader from "../../fragments/CustomPageHeader";

export default function GLClosure({ children }) {
  return (
    <div>
      <CustomPageHeader icon='folder' text='GL closures' />
      { children }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Accounting/GLClosures/index.js